import { ISelectOption } from '$/types'
import { HMCATableViewMode } from 'features/RegulatoryTools/HCAMCA/Components/Tables'

import MapWrapper from './Components/MapWrapper'

interface IMapWrapperGuardProps {
  tableMode: HMCATableViewMode
  hmcaDataId: number | undefined
  classLocationDataId: number | undefined
  selectedDateRange: Array<Date | null>
  selectedLines: ISelectOption[]
  selectedClassifications: ISelectOption[]
}

export const MapWrapperGuard = ({
  tableMode,
  hmcaDataId,
  classLocationDataId,
  selectedDateRange,
  selectedLines,
  selectedClassifications
}: IMapWrapperGuardProps) => {
  let mapAttributeId

  if (tableMode === HMCATableViewMode.HMCA) {
    mapAttributeId = hmcaDataId
  } else {
    mapAttributeId = classLocationDataId
  }

  return (
    <MapWrapper
      tableMode={tableMode}
      mapAttributeId={mapAttributeId}
      selectedDateRange={selectedDateRange}
      selectedLines={selectedLines}
      selectedClassifications={selectedClassifications}
    />
  )
}
